/* tslint:disable */
/* eslint-disable */

import React, { CSSProperties, SVGAttributes, FunctionComponent } from 'react';
import { getIconColor } from './helper';

interface Props extends Omit<SVGAttributes<SVGElement>, 'color'> {
  size?: number;
  color?: string | string[];
}

const DEFAULT_STYLE: CSSProperties = {
  display: 'block',
};

const IconZhuxiaozhanghu: FunctionComponent<Props> = ({ size, color, style: _style, ...rest }) => {
  const style = _style ? { ...DEFAULT_STYLE, ..._style } : DEFAULT_STYLE;

  return (
    <svg viewBox="0 0 1024 1024" width={size + 'px'} height={size + 'px'} style={style} {...rest}>
      <path
        d="M789.738667 555.434667a234.282667 234.282667 0 1 1 0 468.565333 234.282667 234.282667 0 0 1 0-468.565333zM512.021333 0a256 256 0 0 1 147.754667 465.066667c13.653333 4.138667 27.178667 8.832 40.448 14.08a34.304 34.304 0 0 1-25.216 63.744A439.722667 439.722667 0 0 0 512.021333 512h0.085334H512.021333C269.589333 512 72.554667 706.56 68.672 948.096l-0.085333 7.338667a34.304 34.304 0 1 1-68.565334 0C0.021333 724.010667 153.536 528.469333 364.266667 465.066667A256 256 0 0 1 512.021333 0z m277.717334 624a165.717333 165.717333 0 1 0 0 331.434667 165.717333 165.717333 0 0 0 0-331.434667zM512.021333 68.565333a187.434667 187.434667 0 1 0 0 374.869334h-0.085333 0.213333A187.434667 187.434667 0 0 0 512.021333 68.565333z"
        fill={getIconColor(color, 0, '#333333')}
      />
      <path
        d="M709.738667 755.413333h160c22.869333 0 34.261333 11.434667 34.261333 34.304s-11.392 34.261333-34.261333 34.261334h-160c-22.869333 0-34.304-11.392-34.304-34.261334s11.434667-34.304 34.304-34.304z"
        fill={getIconColor(color, 1, '#333333')}
      />
    </svg>
  );
};

IconZhuxiaozhanghu.defaultProps = {
  size: 18,
};

export default IconZhuxiaozhanghu;
